import { Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { MediaModule } from '../media/media.module';
import { BrandingController } from './branding.controller';
import { BrandingService } from './branding.service';

@Module({
  // MediaModule so logo uploads go through the same quota accounting, storage
  // routing and trash retention as every other image. A private upload path
  // here would have bypassed all three.
  imports: [MediaModule],
  controllers: [BrandingController],
  providers: [PrismaService, BrandingService],
  exports: [BrandingService],
})
export class BrandingModule {}
